import { lightTheme, darkTheme } from '../theme';
import type { CustomTheme } from '../../@types/theme';

type GetDesignLibraryProps = {
  unifiedWebCommonVersion?: string;
  unifiedWebAlphaCommonVersion?: string;
};

export const getDesignLibrary = (props?: GetDesignLibraryProps): { [key: string]: string } => {
  if (process.env.IS_LEGACY) {
    return {
      '@oneaudi/unified-web-common': props?.unifiedWebCommonVersion || '*',
    };
  }
  return {
    '@oneaudi/unified-web-alpha-common-v2': props?.unifiedWebAlphaCommonVersion || '*',
  };
};

export const getThemeName = (defaultThemeName?: CustomTheme): CustomTheme => {
  if (process.env.IS_LEGACY) {
    return defaultThemeName || lightTheme;
  }
  return darkTheme;
};
